import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: 0, width: 400 },
};

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 16px 16px;

    & > *:not(:first-child) {
        margin-left: 4px;
    }
`;

export const StyledNameInputLabel = styled(Text)`
    display: flex;
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};

    margin-bottom: 16px;
`;

export const StyledNameInputContainer = styled.div`
    margin-bottom: 32px;
    margin-top: 16px;
    padding: 0 24px;
`;

export const StyledTitle = styled(Text)`
    display: flex;
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};

    margin: 0;
`;

export const StyledHeader = styled.div`
    padding: 20px 24px;
`;

export const StyledModalContent = styled.div``;
